import { useTranslation } from "react-i18next";

import { MkButton } from "./MkButton";
import { MkIcon } from "./MkIcon";
import { MkModal } from "./MkModal";

interface Props {
    open: boolean;
    title: string;
    previewSrc: string;
    disabled?: boolean;
    onPick(): void;
    onClear?(): void;
    onClose(): void;
}

export function MkImageModal({ open, title, previewSrc, disabled, onPick, onClear, onClose }: Props) {
    const { t } = useTranslation();

    return (
        <MkModal open={open} size="sm" title={title} icon="fa-picture-o"
                 onClose={onClose}
                 footer={(
                     <>
                         <MkButton variant="primary" icon="fa-upload"
                                   label={previewSrc ? t("mk.avatar.replace") : t("mk.avatar.upload")}
                                   disabled={disabled} onClick={onPick} />
                         {previewSrc && onClear && (
                             <MkButton variant="danger" icon="fa-trash"
                                       label={t("mk.avatar.remove")} disabled={disabled}
                                       onClick={() => {
                                           if (!disabled) {
                                               onClear();
                                               onClose();
                                           }
                                       }} />
                         )}
                         <MkButton variant="ghost" icon="fa-times" label={t("mk.close")}
                                   onClick={onClose} />
                     </>
                 )}>
            <div className="mk-avatar-editor-preview">
                {previewSrc ? <img src={previewSrc} alt={title} /> : (
                    <div className="mk-avatar-editor-empty">
                        <MkIcon name="fa-picture-o" />
                        <span>{t("mk.avatar.empty")}</span>
                    </div>
                )}
            </div>
        </MkModal>
    );
}
